module.exports = __webpack_public_path__ + "media/components/assets/img/bg/noise-3-9f0de264ff89c03c86befd6918cfc57a.svg";